// src/redux/uploadApi.js
import { apiSlice } from "./apiSlice";

export const uploadApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        uploadImage: build.mutation({
            query: (body) => ({
                url: "/api/user/upload/v1/image",
                method: "post",
                headers: { token: true, "Content-Type": "multipart/form-data" },
                data: body,
            }),
        }),
        uploadImageMultiple: build.mutation({
            query: (body) => ({
                url: "/api/user/upload/v1/image/multiple",
                method: "post",
                headers: { token: true, "Content-Type": "multipart/form-data" },
                data: body,
            }),
        }),
        uploadFile: build.mutation({
            query: (formData) => ({
                url: "/api/user/upload/v1/file",
                method: "post",
                headers: { token: true, "Content-Type": "multipart/form-data" },
                data: formData,
            }),
        }),
    }),
});

export const { useUploadImageMutation, useUploadImageMultipleMutation, useUploadFileMutation } = uploadApi;
